import { useEffect, useState } from 'react';

import { useTickets } from 'contexts/TicketsContext';
import { useUserProfile } from 'contexts/UserProfileContext';

export interface Column {
  id: string;
  label: string;
  visible: boolean;
}

export interface TicketsListHookProps {
  columns: Column[];
}

export interface TicketsListHookResult {
  handleColumnPickerClick: () => void;
  handleTicketSelection: (ticketId: string, roofTopId: string) => void;
  hasNextTicketsPage: boolean | undefined;
  selectedTickets: string[];
  selectedTicketsRooftops: string[];
  setSelectedTickets: (value: string[]) => void;
  setSelectedTicketsRooftops: (value: string[]) => void;
}

export const useTicketsListView = ({
  columns: _columns,
}: TicketsListHookProps): TicketsListHookResult => {
  const [selectedTickets, setSelectedTickets] = useState<string[]>([]);
  const [selectedTicketsRooftops, setSelectedTicketsRooftops] = useState<string[]>([]);

  const { setColumnPickerPopupVisibility } = useUserProfile();
  const {
    setSelectedTicketsIds,
    hasNextTicketsPage,
    setSelectedTicketsRooftopIds,
    selectedTicketsIds,
    selectedRoofTop,
    setEditMode,
  } = useTickets();

  const handleTicketSelection = (ticketId: string, roofTopId: string): void => {
    if (selectedTickets.includes(ticketId)) {
      setSelectedTickets((prev: string[]): string[] => prev.filter(id => id !== ticketId));
      setSelectedTicketsIds(selectedTickets.filter(id => id !== ticketId));
    } else {
      setSelectedTickets((prev: string[]): string[] => [...prev, ticketId]);
      setSelectedTicketsIds([...selectedTickets, ticketId]);
    }

    if (!selectedTicketsRooftops.includes(roofTopId)) {
      setSelectedTicketsRooftops((prev: string[]): string[] => [...prev, roofTopId]);
      setSelectedTicketsRooftopIds([...selectedTicketsRooftops, roofTopId]);
    }
  };

  const handleColumnPickerClick = (): void => {
    setColumnPickerPopupVisibility(true);
  };

  useEffect(() => {
    setSelectedTickets(selectedTicketsIds);
  }, [selectedTicketsIds]);

  useEffect(() => {
    setSelectedTickets([]);
    setSelectedTicketsIds([]);
    setSelectedTicketsRooftops([]);
    setSelectedTicketsRooftopIds([]);
    setEditMode(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedRoofTop]);

  return {
    handleColumnPickerClick,
    handleTicketSelection,
    hasNextTicketsPage,
    selectedTickets,
    selectedTicketsRooftops,
    setSelectedTicketsRooftops,
    setSelectedTickets,
  };
};
